import React from 'react';
import { Box, Image, Anchor } from 'grommet';
import image from 'assets/images/tobakksrullen2026.png';
import pdf from 'assets/pdf/TOBAKKSRULLEN_2026.pdf';

const LocalNewsPaper = () => (
  <Box align="center" justify="center" gap="medium" fill="horizontal">
    <Anchor target="_blank" href={pdf}>
      <Box width={{ max: 'medium' }} margin="medium" fill="horizontal">
        <Image fit="contain" src={image} style={{ maxWidth: '100%' }} />
      </Box>
    </Anchor>
  </Box>
);

export default LocalNewsPaper;
